var _path, _g, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833374 0.833984H18.7442V18.7455H0.833374V0.833984Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0904 16.3965C5.57374 16.3965 6.02957 16.5798 6.51207 16.774C9.46791 18.1407 12.9637 17.519 15.2412 15.2423C18.2462 12.2357 18.2462 7.34482 15.2412 4.33982C13.7862 2.88482 11.8512 2.08398 9.79124 2.08398C7.7304 2.08398 5.79457 2.88565 4.3404 4.34065C2.06207 6.61732 1.44207 10.1132 2.79624 13.0407C2.99124 13.5232 3.17957 13.9932 3.17957 14.4815C3.17957 14.969 3.01207 15.4598 2.86457 15.8932C2.74291 16.2498 2.55874 16.7882 2.67707 16.9065C2.7929 17.0265 3.33457 16.8373 3.69207 16.7148C4.12124 16.5681 4.60791 16.3998 5.0904 16.3965ZM9.7704 18.7456C8.49707 18.7456 7.21541 18.4765 6.01624 17.9215C5.66291 17.7798 5.33207 17.6465 5.09457 17.6465C4.82124 17.6481 4.45374 17.7748 4.09874 17.8973C3.37041 18.1473 2.46374 18.459 1.79291 17.7906C1.12457 17.1215 1.4329 16.2173 1.68124 15.4898C1.80374 15.1315 1.92957 14.7615 1.92957 14.4815C1.92957 14.2515 1.81874 13.9581 1.64874 13.5356C0.0879049 10.1648 0.809572 6.10232 3.45707 3.45648C5.14707 1.76565 7.39624 0.833984 9.79041 0.833984C12.1846 0.833984 14.4346 1.76482 16.1246 3.45565C19.6179 6.94898 19.6179 12.6323 16.1246 16.1256C14.4121 17.839 12.1062 18.7456 9.7704 18.7456Z",
    fill: "#5D6373"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0803 10.9694C12.6203 10.9694 12.2437 10.5969 12.2437 10.1361C12.2437 9.67523 12.6128 9.30273 13.0728 9.30273H13.0803C13.5403 9.30273 13.9137 9.67523 13.9137 10.1361C13.9137 10.5969 13.5403 10.9694 13.0803 10.9694Z",
    fill: "#5D6373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73962 10.9694C9.27962 10.9694 8.90295 10.5969 8.90295 10.1361C8.90295 9.67523 9.27129 9.30273 9.73212 9.30273H9.73962C10.1996 9.30273 10.573 9.67523 10.573 10.1361C10.573 10.5969 10.1996 10.9694 9.73962 10.9694Z",
    fill: "#5D6373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39868 10.9694C5.93868 10.9694 5.56201 10.5969 5.56201 10.1361C5.56201 9.67523 5.93118 9.30273 6.39118 9.30273H6.39868C6.85868 9.30273 7.23201 9.67523 7.23201 10.1361C7.23201 10.5969 6.85868 10.9694 6.39868 10.9694Z",
    fill: "#5D6373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.08eba73c04bfd93c92af02cb42b0efc0.svg";
export { ForwardRef as ReactComponent };